@if (vm$ | async; as vm) {
    <bs-digital-token-summary [summaryMessage]="vm.message" [tokenType]="vm.token?.rewardTokenType" [tokenContext]="tokenContext" />
}
